import { tokens } from "../../../styles/theme";
import Header from "../../../components/Header";
import React, { useEffect, useState } from "react";
import {
  Box,
  FormControlLabel,
  ListSubheader,
  Radio,
  RadioGroup,
  useTheme,
} from "@mui/material";
import axios from "axios";
import ConfirmDialogPaymentMethod from "../global/ConfirmDialogPaymentMethod";
import ConfirmDialogPaymentMethodTwo from "../global/ConfirmDialogPaymentMethodTwo";
import Input from "@material-ui/core/Input";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import ListItemText from "@material-ui/core/ListItemText";
import Select from "@material-ui/core/Select";
import Checkbox from "@material-ui/core/Checkbox";
import {
  DataGridPro,
  GridToolbarContainer,
  GridToolbarColumnsButton,
  GridToolbarFilterButton,
  GridToolbarDensitySelector,
  GridToolbarExport,
} from "@mui/x-data-grid-pro";
import PropTypes from "prop-types";
import packageJson from "../../../../package.json";
import { getAllBanks, getAllPaymentMethods } from "../../../services";
import { getEPaymentConfig } from "../../../services/EPaymentConfig";
export const BaseUrl = packageJson.projectURlApi.BaseUrl;
function EditToolbar(props) {
  return (
    <>
      <GridToolbarContainer>
        <GridToolbarColumnsButton />
        <GridToolbarFilterButton />
        <GridToolbarDensitySelector />
        <GridToolbarExport
          csvOptions={{
            fileName: "التحويلات الواردة",
            utf8WithBom: true,
          }}
        />
      </GridToolbarContainer>
    </>
  );
}
EditToolbar.propTypes = {
  setRowModesModel: PropTypes.func.isRequired,
};

const Ledger = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [users, setUsers] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [confirmDialog, setConfirmDialog] = useState({
    isOpen: false,
    title: "",
    subTitle: "",
  });
  const [confirmDialog1, setConfirmDialog1] = useState({
    isOpen: false,
    title: "",
    subTitle: "",
  });
  const [rowModesModel, setRowModesModel] = React.useState({});
  const [rows, setRows] = React.useState();
  const [personName, setPersonName] = React.useState([]);
  const [fundname, setFundname] = useState([]);
  const [selectedFundCompanies, setSelectedFundCompanies] = useState([]);
  const [orderType, setOrderType] = useState("");
  const [selectedscound, setSelectedscound] = useState(false);
  const [selectedIds, setSelectedIds] = useState([]);
  const [ID, setID] = useState(0);
  const [MultiID, setMultiID] = useState([]);
  const [paymentMethod, setPaymentMethod] = useState([]);
  const [Banks, setBanks] = useState([]);
  const [Paymentconfigration, setGetPaymentconfigration] = useState([]);

  const names = [
    "وحدات Syriatel",
    "فاتورة Syriatel",
    "Syriatel كاش",
    "وحدات MTN",
    "فاتورة MTN",
    "MTN كاش",
  ];
  const type_order = [
    { id: "prepaid", title: "مدفوع" },
    { id: "postpaid", title: "غير مدفوع" },
  ];
  const handleChange = (event) => {


    if (event.target.name === "fund_name") {
      setPersonName(event.target.value);
      setSelectedValue(""); // This will deselect the radio button

      if (orderType == "") {



        const data={
          fund_name:fundname,
        }

  
        axios
        .post(`${BaseUrl}/api/getAllTransactionforMe`,data, {
          withCredentials: true,
        })
        .then(response => {
          setUsers(response.data.data); // Setting users with response data
          setLoading(false);
          setPagination({
            ...pagination,
            total: response.data.pagination.total, // Update total from response
            current_page: response.data.pagination.current_page, // Ensure current page is synced
            total_pages: response.data.pagination.total_pages ,
            count: response.data.pagination.count 
          });
         
        })
        .catch(error => {
          console.error('Failed to fetch data:', error);
          setUsers([]); // Setting users to an empty array in case of error
          setLoading(false);
        
          });


      } else {
        const selectedOptions = event.target.value;
        const order_type = orderType;
     
        const data={
          fund_name:fundname,
          code_name:orderType,
        }
        axios
        .post(`${BaseUrl}/api/getAllTransactionforMe`,data, {
          withCredentials: true,
        })
        .then(response => {
          setUsers(response.data.data); // Setting users with response data
          setLoading(false);
          setPagination({
            ...pagination,
            total: response.data.pagination.total, // Update total from response
            current_page: response.data.pagination.current_page, // Ensure current page is synced
            total_pages: response.data.pagination.total_pages ,
            count: response.data.pagination.count 
          });
         
        })
        .catch(error => {
          console.error('Failed to fetch data:', error);
          setUsers([]); // Setting users to an empty array in case of error
          setLoading(false);
        
          });

      }
    }
    if (event.target.name === "order_type") {
      setOrderType(event.target.value);
      
   
        const data={
          fund_name:fundname,
          code_name:event.target.value,
        }
        axios
        .post(`${BaseUrl}/api/getAllTransactionforMe`,data, {
          withCredentials: true,
        })
        .then(response => {
          setUsers(response.data.data); // Setting users with response data
          setLoading(false);
          setPagination({
            ...pagination,
            total: response.data.pagination.total, // Update total from response
            current_page: response.data.pagination.current_page, // Ensure current page is synced
            total_pages: response.data.pagination.total_pages,
            count: response.data.pagination.count  
          });
        })
        .catch(error => {
          console.error('Failed to fetch data:', error);
          setUsers([]); // Setting users to an empty array in case of error
          setLoading(false);
        
          });
      
    }
  };

  const [selectedValue, setSelectedValue] = useState("ليرتنا كاش");

  // useEffect(() => {
  //   setIsLoading(true);
  //   const filterCondition = row => row.fund_name === 'ليرتنا كاش';
  //   axios
  //     .post(`${BaseUrl}/api/getAllTransactionforMe`, {
  //       withCredentials: true,
  //     })
  //     .then((res) => {
  //         const filteredData = res.data.data.filter(filterCondition);
  //         setUsers(filteredData);

  //       setIsLoading(false);
  //     })
  //     .catch((err) => {
  //       setUsers([]);
  //       setIsLoading(false);
  //     });
  //   return () => {};
  // }, []);
  const [pagination, setPagination] = useState({
    total_pages: 1,
    current_page: 1,
    total: 10, // Initially no total rows known
    count: 10 // Initially no total rows known
  });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    
    
    setIsLoading(true);
    setFundname('ليرتنا كاش')
    const data ={
      page:pagination.current_page,
      fund_name:selectedValue,
    }

    axios
    .post(`${BaseUrl}/api/getAllTransactionforMe`,data, {
      withCredentials: true,
    }
    )
    .then(response => {
      const filteredData = response.data.data;
      setUsers(filteredData);
      setLoading(false);
      setPagination({
        ...pagination,
        total: response.data.pagination.total, // Update total from response
        current_page: response.data.pagination.current_page, // Ensure current page is synced
        total_pages: response.data.pagination.total_pages ,
        count: response.data.pagination.count 
      });
     
    })
    .catch(error => {
      console.error('Failed to fetch data:', error);
      setUsers([]); // Setting users to an empty array in case of error
      setLoading(false);
    
      });
   
  }, []);
  useEffect(() => {},[fundname]);
  useEffect(() => {
    setLoading(true);
    let CodeName;
    if(orderType == ''){

      let data ;
   
      if(fundname.length == 0){
        setFundname('ليرتنا كاش')

        data={
          page:pagination.current_page,
          fund_name:["ليرتنا كاش"],
        }
      }
      else {
    
        data={
          page:pagination.current_page,
          fund_name:fundname,
        }
      }
      axios
      .post(`${BaseUrl}/api/getAllTransactionforMe`,data, {
        withCredentials: true,
      })
      .then(response => {
        setUsers(response.data.data); // Setting users with response data
        setLoading(false);
          setPagination({
            ...pagination,
            total: response.data.pagination.total, // Total items count across all pages
            current_page: response.data.pagination.current_page,
            total_pages: response.data.pagination.total_pages,
            count: response.data.pagination.count 
          });
      
       
      })
      .catch(error => {
        console.error('Failed to fetch data:', error);
        setUsers([]); // Setting users to an empty array in case of error
        setLoading(false);
      
        });
    }else{
      
      CodeName=orderType
      const data ={
        page:pagination.current_page,
        fund_name:fundname,
        code_name:CodeName
      }
      axios
      .post(`${BaseUrl}/api/getAllTransactionforMe`,data, {
        withCredentials: true,
      })
      .then(response => {
        setUsers(response.data.data); // Setting users with response data
        setLoading(false);
        setPagination({
          ...pagination,
          total: response.data.pagination.total, // Total items count across all pages
          current_page: response.data.pagination.current_page,
          total_pages: response.data.pagination.total_pages,
          count: response.data.pagination.count 
        });
       
      })
      .catch(error => {
        console.error('Failed to fetch data:', error);
        setUsers([]); // Setting users to an empty array in case of error
        setLoading(false);
      
        });
    }


  }, [pagination.current_page]);


  const handleRowEditStart = (params, event) => {
    event.defaultMuiPrevented = true;
  };

  const handleRowEditStop = (params, event) => {
    event.defaultMuiPrevented = true;
  };

  const processRowUpdate = (newRow) => {
    const updatedRow = { ...newRow, isNew: false };
    setRows(rows.map((row) => (row.id === newRow.id ? updatedRow : row)));
    return updatedRow;
  };

  const [disableAllRows, setDisableAllRows] = useState(false);

 useEffect(() => {},[MultiID,ID]);
 

  const handleCheckboxChange = (id) => {
    const updatedUsers = users.map((user) => {
      if (user.id === id) {
        return { ...user, isPaid: !user.isPaid }; // Toggle the isPaid status
      }
      return user;
    });
  
    // Determine if the checkbox for the current id is being checked or unchecked
    const isCurrentlyChecked = updatedUsers.find(user => user.id === id).isPaid;
    const userToggled = updatedUsers.find(user => user.id === id);
  
    // Update the selectedIds state based on whether the checkbox is checked or unchecked
    setSelectedIds(prevSelectedIds => {
      if (isCurrentlyChecked) {
        // If the checkbox is checked, add the id to the array
        return [...prevSelectedIds, id];
      } else {
        // If the checkbox is unchecked, remove the id from the array
        return prevSelectedIds.filter(selectedId => selectedId !== id);
      }
    });
  
    // Additionally, check if the fund name is "ليرتنا كاش"
    if (userToggled.fund_name === "ليرتنا كاش") {
      if (isCurrentlyChecked) {
        // If the checkbox for "ليرتنا كاش" is checked, update the ID state with this ID
        setID(id); // Assuming you want to store the ID as a string
      } else {
        // If the checkbox for "ليرتنا كاش" is unchecked, clear the ID state
        setID('');
      }
    }else{
      setMultiID(prevSelectedIds => {
        // Ensure prevSelectedIds is an array
        const safePrevSelectedIds = Array.isArray(prevSelectedIds) ? prevSelectedIds : [];
      
        if (isCurrentlyChecked) {
          // If the checkbox is checked, add the id to the array
          return [...safePrevSelectedIds, id];
        } else {
          // If the checkbox is unchecked, remove the id from the array
          return safePrevSelectedIds.filter(selectedId => selectedId !== id);
        }
      });
    }
    

      const anyDebtAndCashFundChecked = updatedUsers.some(
        (row) => row.isPaid && row.fund_name === "ليرتنا كاش" && row.payment_method === "Debt"
        );
        
        setUsers(updatedUsers); // Update the users state with the new isPaid statuses
        setDisableAllRows(anyDebtAndCashFundChecked); // Update whether all rows should be disabled
      
  };
  
  const columns = [
    {
      field: "staff_from",
      headerName: "المرسل",
      headerAlign: "center",
      align: "center",
      flex: 1,
      cellClassName: "name-column--cell",
      editable: false,
    },
    {
      field: "staff_to",
      headerName: "المستقبل",
      headerAlign: "center",
      align: "center",
      flex: 1,
      cellClassName: "name-column--cell",
      editable: false,
    },
    {
      field: "staff_to_type",
      headerName: "نوع المستقبل",
      headerAlign: "center",
      align: "center",
      flex: 1,
      cellClassName: "name-column--cell",
      editable: false,
    },
    {
      field: "from_mobile_number",
      headerName: "رقم المرسل",
      headerAlign: "center",
      align: "center",
      flex: 1,
      editable: false,
    },
    {
      field: "to_mobile_number",
      headerName: "رقم المستقبل",
      headerAlign: "center",
      align: "center",
      flex: 1,
      cellClassName: "name-column--cell",
      editable: false,
    },
    {
      field: "description",
      headerName: "الوصف",
      headerAlign: "center",
      align: "center",
      flex: 1,
      cellClassName: "name-column--cell",
      editable: false,
    },
    {
      field: "fund_name",
      headerName: "اسم الرصيد",
      headerAlign: "center",
      align: "center",
      flex: 1,
      editable: false,
    },
    {
      field: "fund_company",
      headerName: "رصيد الشركة",
      headerAlign: "center",
      align: "center",
      flex: 1,
      editable: false,
    },
    {
      field: "amount_berfore",
      headerName: "الرصيد قبل ",
      headerAlign: "center",
      align: "center",
      flex: 1,
      editable: false,
    },
    {
      field: "amount_after",
      headerName: "الرصيد بعد ",
      headerAlign: "center",
      align: "center",
      flex: 1,
      editable: false,
    },
    {
      field: "amount",
      headerName: "كمية الرصيد ",
      headerAlign: "center",
      align: "center",
      type: "number",
      flex: 1,
      editable: false,
    },
    {
      field: "code_name",
      headerName: "نوع الطلب",
      headerAlign: "center",
      align: "center",
      flex: 1,
      editable: false,
      renderCell: (params) => {
        const isActive = params.value === "prepaid";
        return isActive ? (
          <p style={{ color: "#403e3e", fontSize: "15px" }}>مدفوع</p>
        ) : (
          <p style={{ color: "#403e3e", fontSize: "15px" }}>غير مدفوع</p>
        );
      },
    },
    {
      field: "payment_method_ar",
      headerName: "طريقة الدفع",
      headerAlign: "center",
      align: "center",
      flex: 1,
      editable: false,
    },

    {
      field: "actions",
      type: "actions",
      headerName: "اجراءات",
      headerAlign: "center",
      align: "center",
      cellClassName: "actions",
      renderCell: (params) => {
        const isDebtAndCashFund =
          params.row.fund_name === "ليرتنا كاش" &&
          params.row.payment_method === "Debt";
        const shouldDisableCheckbox =
          disableAllRows && (!params.row.isPaid || !isDebtAndCashFund);

        return (
          params.row.payment_method === "Debt" ?(

          <Checkbox
            disabled={shouldDisableCheckbox}
            checked={params.row.isPaid}
            onChange={() =>
              handleCheckboxChange(params.row.id, isDebtAndCashFund)
            }
            inputProps={{ "aria-label": "تحويل لمدفوع" }}
          />
          ):(
            <></>
          )
        );
      },
    },
  ];
  const handleCombinedChange = (event,child) => {
    // Assuming 'name' attribute distinguishes the radio buttons and select inputs
    const { name, value } = event.target;
    
    if (event.target.type === 'radio') {
      // users.forEach(user => user.isPaid = false); // Reset the `isPaid` flag for all users
        const resetUsers = users.map(user => ({
          ...user,
          isPaid: false // Reset this flag
      }));

      let filterCondition;
      if (value === 'ليرتنا كاش') {
        setSelectedscound(false);
        setSelectedValue("ليرتنا كاش");
        setFundname("ليرتنا كاش");
        filterCondition = row => row.fund_name === 'ليرتنا كاش';
        const data={
          fund_name:['ليرتنا كاش'],
        }
    
        axios
        .post(`${BaseUrl}/api/getAllTransactionforMe`,data, {
          withCredentials: true,
        }
        )
        .then(response => {
          const filteredData = response.data.data;
          setUsers(filteredData);
          setLoading(false);
          setPagination({
            ...pagination,
            total: response.data.pagination.total, // Update total from response
            current_page: response.data.pagination.current_page, // Ensure current page is synced
            total_pages: response.data.pagination.total_pages ,
            count: response.data.pagination.count 
          });
         
        })
        .catch(error => {
          console.error('Failed to fetch data:', error);
          setUsers([]); // Setting users to an empty array in case of error
          setLoading(false);
        
          });
      } else {
        setSelectedscound(true);
        setSelectedValue("رصيد شركات الاتصالات");
        filterCondition = row => row.fund_name !== 'ليرتنا كاش';
      }
      // const data={
      //   fund_name:personName,
      //   code_name:orderType,
      // }
  
      // axios
      // .post(`${BaseUrl}/api/getAllTransactionforMe`,data, {
      //   withCredentials: true,
      // }
      // )
      // .then(response => {
      //   const filteredData = response.data.data;
      //   setUsers(filteredData);
      //   setLoading(false);
      //   setPagination({
      //     ...pagination,
      //     total: response.data.pagination.total_pages, // Update total from response
      //     current_page: response.data.pagination.current_page // Ensure current page is synced
      //   });
       
      // })
      // .catch(error => {
      //   console.error('Failed to fetch data:', error);
      //   setUsers([]); // Setting users to an empty array in case of error
      //   setLoading(false);
      
      //   });


      // axios.post(`${BaseUrl}/api/getAllTransactionforMe`, { withCredentials: true })
      //   .then((res) => {
      //     const filteredData = res.data.data.filter(filterCondition);
      //     setUsers(filteredData);
      //     setIsLoading(false);
      //     setSelectedIds([]); // Clear selected IDs
      //     setID(0); // Reset ID
      //     setMultiID([]); 
      //     setDisableAllRows(false); // Enable all rows again
      //   })
      //   .catch((error) => {
      //     setIsLoading(false);
      //   });
    
    }
    else if (event.target.type === 'checkbox') {
      const name = child.props.value;
      let newPersonName = [...personName];

      if (event.target.checked) {
        // Add the value if the checkbox is checked
        if (!newPersonName.includes(name)) {
          newPersonName.push(name);
          setFundname(newPersonName);

          const data={
            fund_name:newPersonName,
          }
      
          axios
          .post(`${BaseUrl}/api/getAllTransactionforMe`,data, {
            withCredentials: true,
          }
          )
          .then(response => {
            const filteredData = response.data.data;
            setUsers(filteredData);
            setLoading(false);
            setPagination({
              ...pagination,
              total: response.data.pagination.total, // Update total from response
              current_page: response.data.pagination.current_page, // Ensure current page is synced
              total_pages: response.data.pagination.total_pages ,
              count: response.data.pagination.count 
            });
           
          })
          .catch(error => {
            console.error('Failed to fetch data:', error);
            setUsers([]); // Setting users to an empty array in case of error
            setLoading(false);
          
            });

        
        }
        
      } else {
        
        newPersonName = newPersonName.filter(item => item !== name);
        if(newPersonName.length == 0){
          const data={
            page:1,
          }
      
          axios
          .post(`${BaseUrl}/api/getAllTransactionforMe`,data, {
            withCredentials: true,
          }
          )
          .then(response => {
            const allData = response.data.data;
            // Filter data to only include entries where 'fund_name' equals 'ليرتنا كاش'
            const filteredData = allData.filter(item => item.fund_name != 'ليرتنا كاش');
        
            setUsers(filteredData);
            setLoading(false);
            setPagination({
              ...pagination,
              total: response.data.pagination.total, // Update total from response
              current_page: response.data.pagination.current_page, // Ensure current page is synced
              total_pages: response.data.pagination.total_pages ,
              count: response.data.pagination.count 
            });
           
          })
          .catch(error => {
            console.error('Failed to fetch data:', error);
            setUsers([]); // Setting users to an empty array in case of error
            setLoading(false);
          
            });

        }else{
          const data={
            fund_name:newPersonName,
          }
      
          axios
          .post(`${BaseUrl}/api/getAllTransactionforMe`,data, {
            withCredentials: true,
          }
          )
          .then(response => {
            const filteredData = response.data.data;
            setUsers(filteredData);
            setLoading(false);
            setPagination({
              ...pagination,
              total: response.data.pagination.total, // Update total from response
              current_page: response.data.pagination.current_page, // Ensure current page is synced
              total_pages: response.data.pagination.total_pages ,
              count: response.data.pagination.count 
            });
           
          })
          .catch(error => {
            console.error('Failed to fetch data:', error);
            setUsers([]); // Setting users to an empty array in case of error
            setLoading(false);
          
            });
        }
      }
  
      setPersonName(newPersonName);
  
      // You may continue with your fetching/filtering logic here using `newPersonName`
    
      if (event.target.name === "fund_name") {
        setPersonName(event.target.value);
        setSelectedValue(""); // This will deselect the radio button
  
        // if (orderType == "") {
        //   const selectedOptions = event.target.value;
        //   axios
        //     .post(`${BaseUrl}/api/getAllTransactionforMe`, {
        //       withCredentials: true,
        //     })
        //     .then((res) => {
        //       const filteredData = res.data.data.filter((row) =>
        //         selectedOptions.includes(row.fund_name)
        //       );
        //       setUsers(filteredData);
  
        //       setIsLoading(false);
        //     })
        //     .catch((error) => {
        //       setIsLoading(false);
        //     });
        // } else {
        //   const selectedOptions = event.target.value;
        //   const order_type = orderType;
        //   axios
        //     .post(`${BaseUrl}/api/getAllTransactionforMe`, {
        //       withCredentials: true,
        //     })
        //     .then((res) => {
        //       const filteredData = res.data.data.filter(
        //         (row) =>
        //           selectedOptions.includes(row.fund_name) &&
        //           order_type.includes(row.code_name)
        //       );
  
        //       setUsers(filteredData);
        //       setIsLoading(false);
        //       setSelectedValue(""); // This will deselect the radio button
        //     })
        //     .catch((error) => {
        //       setIsLoading(false);
        //     });
        // }
      }

      // if (event.target.name === "order_type") {
      //   setOrderType(event.target.value);
      //   if (personName == "") {
      //     const selectedOptions = event.target.value;
      //     axios
      //       .post(`${BaseUrl}/api/getAllTransactionforMe`, {
      //         withCredentials: true,
      //       })
      //       .then((res) => {
      //         const filteredData = res.data.data.filter((row) =>
      //           selectedOptions.includes(row.code_name)
      //         );
  
      //         setUsers(filteredData);
      //         setIsLoading(false);
      //       })
      //       .catch((error) => {
      //         setIsLoading(false);
      //       });
      //   } else {
      //     const selectedOptions = event.target.value;
      //     const order_type = personName;
      //     axios
      //       .post(`${BaseUrl}/api/getAllTransactionforMe`, {
      //         withCredentials: true,
      //       })
      //       .then((res) => {
      //         const filteredData = res.data.data.filter(
      //           (row) =>
      //             selectedOptions.includes(row.code_name) &&
      //             order_type.includes(row.fund_name)
      //         );
  
      //         setUsers(filteredData);
      //         setIsLoading(false);
      //       })
      //       .catch((error) => {
      //         setIsLoading(false);
      //       });
      //   }
      // }

    }
  };

  useEffect(() => {
    getAllPaymentMethods().then((res) => {
      setPaymentMethod(res.data);
    });
    getAllBanks().then((res) => {
      setBanks(res);
    });
    getEPaymentConfig().then((res) => {
      setGetPaymentconfigration(res);

      // setIsLoading(true);
    });
    return () => {};
  }, []);
  // useEffect(() => {
  // alert('2')
  
  //   // Data object constructed based on the condition
  //   const data = {
  //     page: pagination.current_page,
  //     fund_name: fundname,
  //     ...(orderType && { code_name: orderType })
  //   };
  
  //   axios.post(`${BaseUrl}/api/getAllTransactionforMe`, data, { withCredentials: true })
  //     .then(response => {
  //       console.log(response.data, 'data'); // Logging the data for debugging
  //       setUsers(response.data.data); // Setting users with response data
  //       setLoading(false);
  //       setPagination(prev => ({
  //         ...prev,
  //         total: response.data.pagination.total_pages, // Update total from response
  //         current_page: response.data.pagination.current_page // Sync current page
  //       }));
  //     })
  //     .catch(error => {
  //       console.error('Failed to fetch data:', error);
  //       setUsers([]); // Setting users to an empty array in case of error
  //       setLoading(false);
  //     });
  
  // }, [pagination.current_page]); // Dependency on current_page only
  
  // const handlePageChange = (newPage) => {
  //   setPagination(prev => ({
  //     ...prev,
  //     current_page: newPage + 1 // Incrementing page by 1, assuming 'newPage' is zero-based
  //   }));
    
  // };
  
  // Dependency on current_page only
  // useEffect(() => {
  //   setLoading(true);
  //   alert('kkkk')
  //   // Data object constructed based on the condition
  //   const data = {
  //     page: pagination.current_page,
  //     fund_name: fundname,
  //     ...(orderType && { code_name: orderType })
  //   };
  
  //   axios.post(`${BaseUrl}/api/getAllTransactionforMe`, data, { withCredentials: true })
  //     .then(response => {
  //       console.log(response.data, 'data'); // Logging the data for debugging
  //       setUsers(response.data.data); // Setting users with response data
  //       setLoading(false);
  //       setPagination(prev => ({
  //         ...prev,
  //         total: response.data.pagination.total_pages, // Update total from response
  //         current_page: response.data.pagination.current_page ,// Sync current page
  //         total_pages: response.data.pagination.total_pages ,
  //         count: response.data.pagination.count 
  //       }));
  //     })
  //     .catch(error => {
  //       console.error('Failed to fetch data:', error);
  //       setUsers([]); // Setting users to an empty array in case of error
  //       setLoading(false);
  //     });
  
  // }, [pagination.current_page]); // Dependency on current_page only
  
  const handlePageChange = (newPage) => {
    
    setPagination(prev => ({
      ...prev,
      current_page: newPage + 1
    }));
    
  };


  return (
    <Box m="2px 5px 0px 5px">
      <Header />

      <Box
        m="40px 0 0 0"
        height="75vh"
        sx={{
          "& .MuiDataGrid-root": {
            border: "none",
          },
          "& .MuiDataGrid-cell": {
            borderBottom: "none",
          },
          "& .name-column--cell": {
            color: colors.redAccent[1100],
          },
          "& .MuiDataGrid-columnHeaders": {
            backgroundColor: colors.redAccent[1100],
            borderBottom: "none",
            fontSize: "10px !important",
          },
          "& .MuiDataGrid-cellContent": {
            fontSize: "10px !important",
            color: `${colors.grey[600]} !important`,
          },
          "& .MuiDataGrid-virtualScroller": {
            backgroundColor: colors.white[100],
          },
          "& .MuiDataGrid-footerContainer": {
            borderTop: "none",
            backgroundColor: colors.redAccent[1100],
          },
          "& .MuiCheckbox-root": {
            color: `${colors.greenAccent[200]} !important`,
          },
        }}
      >
        <ConfirmDialogPaymentMethod
          confirmDialog={confirmDialog}
          setConfirmDialog={setConfirmDialog}
          id={ID}
          setPaymentMethod={setPaymentMethod}
          paymentMethod={paymentMethod}
          Banks={Banks}
          setBanks={setBanks}
          setGetPaymentconfigration={setGetPaymentconfigration}
          Paymentconfigration={Paymentconfigration}
        />
        <>
          <FormControl style={{ width: "300px", marginRight: "20px" }}>
            {/* <FormControl component="fieldset">
            </FormControl> */}
            <InputLabel
              id="demo-mutiple-checkbox-label"
              style={{ color: "#297FB8", fontSize: "20px", width: "200px" }}
            >
              فلترة حسب اسم الرصيد
            </InputLabel>
            <Select
              multiple
              value={personName}
              onChange={handleCombinedChange}
              input={<Input />}
              renderValue={(selected) => selected.join(", ")}
              name="fund_name"
            >
              <ListSubheader
                style={{ marginBottom: "15px", background: "#297fb8" }}
              >
                فلترة حسب الارصدة
              </ListSubheader>

              <RadioGroup
                aria-label="ليرتنا"
                name=""
                value={selectedValue}
                defaultValue={selectedValue}
                onChange={handleCombinedChange}
              >
                <FormControlLabel
                  value="ليرتنا كاش"
                  control={<Radio  />}
                  label="ليرتنا"
                />
                <FormControlLabel
                  value="رصيد شركات الاتصالات"
                  control={<Radio />}
                  label="رصيد شركات الاتصالات"
                />
              </RadioGroup>
            {selectedscound  == true ?(
<>
            
                <ListSubheader
                  style={{ marginTop: "15px", background: "#297fb8" }}
                >
                  رصيد شركة الاتصالات
                </ListSubheader>
                {selectedscound === true && names.map((name) => (
                    <MenuItem key={name} value={name} >
                      <Checkbox
                        checked={personName.includes(name)}
                        onChange={(event) => handleCombinedChange(event,{props: {value: name}})} // Make sure the handler is called when checkbox changes
                      />
                      <ListItemText primary={name} />
                    </MenuItem>
                  ))}
             
  </>)
              :(
              <></>
              )}
            </Select>
          </FormControl>
          <FormControl style={{ width: "300px", marginRight: "20px" }}>
            <InputLabel
              id="demo-mutiple-checkbox-label1"
              style={{ color: "#297FB8", fontSize: "20px", width: "200px" }}
            >
              فلترة حسب نوع الطلب
            </InputLabel>
            <Select
              value={orderType}
              onChange={handleChange}
              input={<Input />}
              name="order_type"
            >
              {type_order.map((option) => (
                <MenuItem key={option.id} value={option.id}>
                  {option.title}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </>
        
        {ID !== 0 ?(
          <Box style={{ display: "flex", justifyContent: "end" , cursor:'pointer'}}>
          <button
            style={{cursor:'pointer'}}
            variant="contained"
            className="activationbtn8"
            onClick={() => {
              setConfirmDialog({
                isOpen: true,
                title: "اختر طريفة الدفع",
                subTitle: "لايمكن التراجع عن هذه العملية",
                onConfirm: () => {
                  
                },
              });
            }}
          >
            تحويل لمدفوع
          </button>
        </Box>
        ):(
          <></>
        )}
        {MultiID.length > 0 ?(
          <Box style={{ display: "flex", justifyContent: "end" , cursor:'pointer'}}>
          <button
          style={{cursor:'pointer'}}
            variant="contained"
            className="activationbtn8"
            onClick={() => {
              setConfirmDialog1({
                isOpen: true,
                title: "اختر طريفة الدفع",
                subTitle: "لايمكن التراجع عن هذه العملية",
                onConfirm: () => {
                  
                },
              });
            }}
          >
            تحويل لمدفوع
          </button>
        </Box>
        ):(
          <></>
        )}

        <ConfirmDialogPaymentMethodTwo
          confirmDialog={confirmDialog1}
          setConfirmDialog={setConfirmDialog1}
          id={MultiID}
          setPaymentMethod={setPaymentMethod}
          paymentMethod={paymentMethod}
          Banks={Banks}
          setBanks={setBanks}
          setGetPaymentconfigration={setGetPaymentconfigration}
          Paymentconfigration={Paymentconfigration}
        />
        {/* <DataGridPro
          rows={users}
          className="field-table"
          columns={columns}
          editMode="row"
          pageSize={pagination.count}
          rowCount={pagination.total} // Total number of rows
          pagination

          onPageChange={handlePageChange}
          page={pagination.current_page - 1} 
          rowModesModel={rowModesModel}
          onRowModesModelChange={(newModel) => setRowModesModel(newModel)}
          onRowEditStart={handleRowEditStart}
          onRowEditStop={handleRowEditStop}
          processRowUpdate={processRowUpdate}
          components={{
            Toolbar: EditToolbar,
          }}
          localeText={{
            toolbarColumns: "الأعمدة",
            toolbarFilters: "الفلاتر",
            toolbarDensity: "التباعد",
            toolbarExport: "تصدير",
            filterPanelAddFilter: "إضافة فلتر",
            filterOperatorContains: "تحتوي",
            filterOperatorEquals: "تساوي",
            filterOperatorStartsWith: "تبدأ ب",
            filterOperatorEndsWith: "تنتهي  ب",
            filterOperatorIsAnyOf: "هو أي من",
            filterOperatorIsEmpty: "فارغ",
            filterOperatorIsNotEmpty: "غير فارغ",
            toolbarDensityCompact: "دمج",
            toolbarDensityStandard: "معيار",
            toolbarDensityComfortable: "مريح",
            toolbarExportCSV: "تصدير CSV",
            toolbarExportPrint: "طباعة",
            filterPanelInputLabel: "القيمة",
            filterPanelInputPlaceholder: "ادخل القيمة",
            filterPanelColumns: "الاعمدة",
            filterPanelOperators: "العمليات",
            columnsPanelTextFieldLabel: "بحث عن عمود",
            columnsPanelTextFieldPlaceholder: "عنوان العمود",
          }}
          componentsProps={{
            toolbar: { setRows, setRowModesModel },
          }}
          experimentalFeatures={{ newEditingApi: true }}
        /> */}

        <DataGridPro
          rows={users}
          className="field-table"
          columns={columns}
          editMode="row"
          pageSize={10}
          rowCount={pagination.total} // Total number of rows
          pagination
          paginationMode="server" // Set pagination mode to server
          onPageChange={handlePageChange}
          page={pagination.current_page - 1} // Set the current page
          rowModesModel={rowModesModel}
          onRowModesModelChange={(newModel) => setRowModesModel(newModel)}
          onRowEditStart={handleRowEditStart}
          onRowEditStop={handleRowEditStop}
          processRowUpdate={processRowUpdate}
          components={{
            Toolbar: EditToolbar,
          }}
          localeText={{
            toolbarColumns: "الأعمدة",
            toolbarFilters: "الفلاتر",
            toolbarDensity: "التباعد",
            toolbarExport: "تصدير",
            filterPanelAddFilter: "إضافة فلتر",
            filterOperatorContains: "تحتوي",
            filterOperatorEquals: "تساوي",
            filterOperatorStartsWith: "تبدأ ب",
            filterOperatorEndsWith: "تنتهي  ب",
            filterOperatorIsAnyOf: "هو أي من",
            filterOperatorIsEmpty: "فارغ",
            filterOperatorIsNotEmpty: "غير فارغ",
            toolbarDensityCompact: "دمج",
            toolbarDensityStandard: "معيار",
            toolbarDensityComfortable: "مريح",
            toolbarExportCSV: "تصدير CSV",
            toolbarExportPrint: "طباعة",
            filterPanelInputLabel: "القيمة",
            filterPanelInputPlaceholder: "ادخل القيمة",
            filterPanelColumns: "الاعمدة",
            filterPanelOperators: "العمليات",
            columnsPanelTextFieldLabel: "بحث عن عمود",
            columnsPanelTextFieldPlaceholder: "عنوان العمود",
          }}
          componentsProps={{
            toolbar: { setRows, setRowModesModel },
          }}
          experimentalFeatures={{ newEditingApi: true }}
      
        />
      </Box>
    </Box>
  );
};

export default Ledger;
